__webpack_require__.p = "/corecards/";